import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import M from 'materialize-css';
import { compose } from 'redux';
import { firestoreConnect } from 'react-redux-firebase';
import { storage } from '../../config/fbConfig';

function NewCompany(props) {
  const [companyName, setCompanyName] = useState('');
  const [companyLogo, setCompanyLogo] = useState('');
  const [companyLogoUrl, setCompanyLogoUrl] = useState('');
  const [circleLogo, setCircleLogo] = useState('');
  const [circleLogoUrl, setCircleLogoUrl] = useState('');
  const [rewardImage, setRewardImage] = useState('');
  const [rewardImageUrl, setRewardImageUrl] = useState('');
  const [ngcVendorCode, setNgcVendorCode] = useState('');
  const [denominations, setDenominations] = useState('');
  const [marketingMessage, setMarketingMessage] = useState('');
  const [termsAndConditions, setTermsAndConditions] = useState('');
  const [countryCode, setCountryCode] = useState('');
  const [disableRedemption, setDisableRedemption] = useState(false);
  const [pynCardOff, setPynCardOff] = useState(false);
  const [redirectToCompanies, setRedirecToCompanies] = useState(false);
  const [safetyPynMessage, setSafetyPynMessage] = useState('');
  const { firestore } = props;

  useEffect(() => {
    M.AutoInit();
  }, []);

  const getRedeemRules = (denominations) => {
    const points = [];
    const pyns = [];

    for (var index in denominations) {
      const denomination = denominations[index];

      const keyPoint = (denomination * 100).toString();
      const point = {};
      point[keyPoint] = denomination;
      points.push(point);

      const keyPyn = (denomination * 5).toString();
      const pyn = {};
      pyn[keyPyn] = denomination;
      pyns.push(pyn);
    }

    const redeemRules = {
      point: points,
      pyn: pyns,
    };

    return redeemRules;
  };

  const cleanDenominations = (denominations) => {
    return denominations.replace(/\s/g, '');
  };

  const genString = (length) => {
    var result = '';
    var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  };

  const uploadImage = (folder, file, newImageurl) => {
    const newFileName = genString(5) + file.name;
    const uploadTask = storage.ref(`/${folder}/${newFileName}`).put(file);

    uploadTask.on(
      'state_changed',
      (snapShot) => {
        console.log(snapShot);
      },
      (err) => {
        console.error(err);
      },
      () => {
        storage
          .ref(folder)
          .child(newFileName)
          .getDownloadURL()
          .then((fireBaseUrl) => {
            console.log(fireBaseUrl);
            newImageurl(fireBaseUrl);
          });
      },
    );
  };

  const validateCompany = () => {
    //TODO: implement it.
    return true;
  };

  const createCompany = () => {
    const den = cleanDenominations(denominations);
    const denArray = den.split(',');

    const newCompany = {
      createdAt: firestore.FieldValue.serverTimestamp(),
      updatedAt: firestore.FieldValue.serverTimestamp(),
      geoFenceColSetTL: false,
      companyName: companyName,
      countryCode: countryCode,
      ngcVendorCode: ngcVendorCode,
      redeemRules: getRedeemRules(denArray),
      denominations: den,
      marketing: marketingMessage,
      termsAndConditions: termsAndConditions,
      disableRedemption: disableRedemption,
      pynCardOff: pynCardOff,
      safetyPynMessage: safetyPynMessage,
    };

    if (!validateCompany(newCompany)) {
      alert('Company no valid');
      return;
    }

    const ref = firestore.collection('companies').doc();
    const docId = ref.id;
    ref.set({ id: docId, uid: docId, ...newCompany })
      .then((docRef) => {
        setRedirecToCompanies(true);
        if (rewardImage) {
          uploadImage('banners', rewardImage, (imageUrl) => {
            setRewardImageUrl(imageUrl);
            firestore.collection('companies').doc(docId).update({ bannerUrl: imageUrl });
          });
        } else {
          setRewardImageUrl('0');
        }

        if (companyLogo) {
          uploadImage('iconCompanies', companyLogo, (imageUrl) => {
            setCompanyLogoUrl(imageUrl);
            firestore.collection('companies').doc(docId).update({ iconUrl: imageUrl });
          });
        } else {
          setCompanyLogoUrl('0');
        }

        if (circleLogo) {
          uploadImage('circleIconCompanies', circleLogo, (imageUrl) => {
            setCircleLogoUrl(imageUrl);
            firestore.collection('companies').doc(docId).update({ circleIconUrl: imageUrl });
          });
        } else {
          setCircleLogoUrl('0');
        }
      })
      .catch((error) => console.error(error));
  };

  const { auth } = props;
  if (!auth.uid) return <Redirect to="/signin" />;
  if (redirectToCompanies && rewardImageUrl && companyLogoUrl) return <Redirect to="/companies" />;

  return (
    <div className="container">
      <div className="card z-depth-2 project-summary">
        <form className="col s12 new-form">
          <div className="card-content">
            <div className="row">
              <div className="col s4">
                <h3>New Company</h3>
              </div>
              <div className="col s4">
                <img src={companyLogoUrl} alt="Company Logo" className="company-logo" />
              </div>
              <div className="col s4">
                <img src={circleLogoUrl} alt="Circle Company Logo" className="circle-icon-logo" />
              </div>
              <div className="col s4">
                <img src={rewardImageUrl} alt="Reward" className="reward-image" />
              </div>
            </div>
            <div className="row">
              <div className="input-field col s12">
                <input id="company_name" type="text" className="validate" name="companyName" value={companyName} onChange={(e) => setCompanyName(e.target.value)} />
                <label htmlFor="company_name">Company Name</label>
              </div>
              <div className="col s12">
                <div className="file-field input-field ">
                  <div className="btn">
                    <span>Company Logo</span>
                    <input type="file" onChange={(e) => setCompanyLogo(e.target.files[0])} />
                  </div>
                  <div className="file-path-wrapper">
                    <input className="file-path validate" type="text" />
                  </div>
                </div>
              </div>
              <div className="col s12">
                <div className="file-field input-field ">
                  <div className="btn">
                    <span>Circle Company Logo</span>
                    <input type="file" onChange={(e) => setCircleLogo(e.target.files[0])} />
                  </div>
                  <div className="file-path-wrapper">
                    <input className="file-path validate" type="text" />
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="input-field col s12">
                <select className="icons" value={countryCode} onChange={(e) => setCountryCode(e.target.value)}>
                  <option value="" disabled>
                    Select your Country
                  </option>
                  <option data-icon="images/ca.svg" value="CA">
                    Canada
                  </option>
                  <option data-icon="images/us.svg" value="US">
                    United States
                  </option>
                  <option data-icon="images/bo.svg" value="BO">
                    Bolivia
                  </option>
                </select>
                <label>Country</label>
              </div>
            </div>
            <div className="row">
              <div className="input-field col s12">
                <input id="ngc_vendor_code" type="text" className="validate" name="ngcVendorcode" value={ngcVendorCode} onChange={(e) => setNgcVendorCode(e.target.value)} />
                <label htmlFor="ngc_vendor_code">NGC Vendor Code</label>
              </div>
              <div className="input-field col s12">
                <input id="denominations" type="text" className="validate" name="denominations" value={denominations} onChange={(e) => setDenominations(e.target.value)} />
                <label htmlFor="denominations">Denominations (ex: 2,5,10)</label>
              </div>
              <div className="col s12">
                <div className="file-field input-field ">
                  <div className="btn">
                    <span>Reward Card Image</span>
                    <input type="file" onChange={(e) => setRewardImage(e.target.files[0])} />
                  </div>
                  <div className="file-path-wrapper">
                    <input className="file-path validate" type="text" />
                  </div>
                </div>
              </div>
              <div className="input-field col s12">
                <textarea id="textarea1" className="materialize-textarea" name="marketingMessage" value={marketingMessage} onChange={(e) => setMarketingMessage(e.target.value)}></textarea>
                <label htmlFor="textarea1">Marketing Message</label>
              </div>
              <div className="input-field col s12">
                <textarea id="textarea1" className="materialize-textarea" name="termsAndConditions" value={termsAndConditions} onChange={(e) => setTermsAndConditions(e.target.value)}></textarea>
                <label htmlFor="textarea1">Terms and Conditions</label>
              </div>
              <div className="input-field col s12">
                <textarea id="safetyPynMsg" className="materialize-textarea" name="termsAndConditions" value={safetyPynMessage} onChange={(e) => setSafetyPynMessage(e.target.value)}></textarea>
                <label htmlFor="safetyPynMsg">Safety pyn message</label>
              </div>
            </div>
            <div className="row">
              <div className="col s6">
                <label>Disable Redemption</label>
                <div className="switch">
                  <label>
                    <input type="checkbox" value={disableRedemption} onChange={(e) => setDisableRedemption(e.target.checked)} />
                    <span className="lever"></span>
                  </label>
                </div>
              </div>
              <div className="col s6">
                <label>Pyn Card Off</label>
                <div className="switch">
                  <label>
                    <input type="checkbox" value={pynCardOff} onChange={(e) => setPynCardOff(e.target.checked)} />
                    <span className="lever"></span>
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div className="card-action">
            <a href="#create" className="waves-effect waves-light btn btn-large" onClick={createCompany}>
              Create
            </a>
          </div>
        </form>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    auth: state.firebase.auth,
  };
};

export default compose(firestoreConnect(), connect(mapStateToProps))(NewCompany);
